import { Injectable } from '@angular/core';
import { WorkExportInput } from '@libs/types/src/services/input-type/work/work.export-input';
import { downloadFile } from '../../../../shared/helpers/file-download.helper';
import { toSignal } from '@angular/core/rxjs-interop';
import {
    selectCurrentServiceId,
    selectFolder,
    selectFolderId,
    selectServices,
} from '../../../store/person/person.selectors';
import { globalStore } from '../../../../shared/shared.global-service';
import { map } from 'rxjs/operators';
import { getSharingFolderIds } from '../../../../../utils/folder.utils';
import {
    SERVICE_SETTINGS_DOCTOR_RECORD_TYPE_KEY,
} from '@libs/types/src/services/types/service-settings-doctor-record.type';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';

@Injectable()
export class FolderDoctorRecordsPageStore extends ComponentStoreV2Factory {

    folder = toSignal(globalStore!.select(selectFolder));
    folderId = toSignal(globalStore!.select(selectFolderId));
    serviceId = toSignal(globalStore!.select(selectCurrentServiceId));
    doctorRecordSharingIds = toSignal(globalStore!.select(selectServices).pipe(
        map((services) =>
            getSharingFolderIds(this.serviceId(), services, this.folder()?.relatedFolders, SERVICE_SETTINGS_DOCTOR_RECORD_TYPE_KEY),
        ),
    ));

    async exportWorks(input: WorkExportInput) {
        const document = await this.api.exportWorks(input);
        if (document) {
            downloadFile(document.pdfBase64, document.fileName, 'application/pdf');
        }
    }

}
